import { render } from "./BasicTemplate2.vue?vue&type=template&id=7d3a75a7&scoped=true"
import script from "./BasicTemplate2.vue?vue&type=script&lang=js"
export * from "./BasicTemplate2.vue?vue&type=script&lang=js"

import "./BasicTemplate2.vue?vue&type=style&index=0&id=7d3a75a7&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3a75a7"]])

export default __exports__